import axios from 'axios';

import { authClear, authUser } from './authentication.script';
import { attachRetryInterceptor, attachRefreshInterceptor, isRefreshing } from './axios.resilience';

export { isRefreshing }

export function mainInterceptor() {
  const requestId = axios.interceptors.request.use(
    (request) => {
      // Only block if the user cookie is completely gone (full sign-out).
      // Do NOT check access/expiry here — the response interceptor handles
      // expired tokens via 401 → refresh → replay.
      if (!authUser()) {
        authClear()
        return Promise.reject(new Error('Session expired'))
      }
      return request
    }
  )

  // Attach shared resilience interceptors to the global axios instance.
  // Order matters: retry runs first, then 401 refresh.
  const retryId = attachRetryInterceptor(axios)
  const refreshId = attachRefreshInterceptor(axios)

  return { requestId, retryId, refreshId }
}
